import 'reflect-metadata';

// Constants
export const VALIDATEPROPERTY__METADATA_KEY = "validateProperty";

/**
 * The metadata interfaces
 */
export interface IValidateMetaData<T> {

    required?       : boolean;
    maxLength?      : number;
    minLength?      : number;
    positiveNumber? : boolean;

    // Used for dynamically deciding if the property is required or not
    requiredFn?     : any;

    // For array types
    minChildren?: number;
    validateAnyChildren?: boolean;
}

/**
 * Decorator for a variety of metadata options
 * @param metadata The metadata object of possible information
 */
export function ValidateProperty<T>(metadata?: IValidateMetaData<T> | string): any {

    const metadataObj = metadata as IValidateMetaData<T>;
    return Reflect.metadata(VALIDATEPROPERTY__METADATA_KEY, {
        required  : metadataObj ? metadataObj.required : false,
        requiredFn  : metadataObj ? metadataObj.requiredFn : undefined,
        maxLength : metadataObj ? metadataObj.maxLength : Number.MAX_SAFE_INTEGER,
        minLength : metadataObj ? metadataObj.minLength : Number.MIN_SAFE_INTEGER,
        minChildren : metadataObj ? metadataObj.minChildren : Number.MIN_SAFE_INTEGER,
        validateAnyChildren : metadataObj ? metadataObj.validateAnyChildren : false,
        positiveNumber  : metadataObj ? metadataObj.positiveNumber : false
    });
}
